import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

export interface Point {
  x: string;
  y: string;
}

export interface IDrawingProps {
  points: Array<Point>;
  type: string;
}

const removePx = (stringNumber: any) =>
  !isNaN(stringNumber)
    ? stringNumber
    : stringNumber.indexOf('px') >= 0
    ? stringNumber.replace('px', '')
    : '0';

const pointsToPathD = (points: Array<Point>, type: string) =>
  'M' +
  points
    .map(
      (point, index) =>
        `${index ? 'L' : ''} ${removePx(point.x)} ${removePx(point.y)} `
    )
    .join('') +
  `${type === 'NoGoZone' ? 'Z' : ''}`;

const SVG = styled.svg`
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
`;

const attrs = {
  fill: 'rgb(168, 64, 104)',
  stroke: 'rgb(168, 64, 104)',
  strokeWidth: '2px',
  strokeDasharray: '1,0.2',
};

export default function Drawing(props: IDrawingProps) {
  const [pathD, setPathD] = useState<any>();
  const { type } = props;

  useEffect(() => {
    setPathD(pointsToPathD(props.points, type));
  }, [props.points, type]);
  return (
    <SVG>
      <path {...attrs} d={pathD} />
    </SVG>
  );
}
